import { Modal } from '@/components/Layout';
import { Button, TextField } from '@/components/Common';
import { TextfieldType } from '@/components/Common/TextField/TextField.types';
import { useTipsList } from './TipsList.hook';
import { FieldError } from 'react-hook-form';

const AddNewTips = () => {
  const {
    isOpenModal,
    setIsOpenModal,
    registerTipByCategory,
    handleSubmitTipByCategory,
    errorsTipByCategory,
    addTipByCategoryHandler,
    isAddingTipByCategory,
  } = useTipsList();

  return (
    <Modal
      isOpen={isOpenModal}
      onClose={() => setIsOpenModal(false)}
      modalStyle="bg-[#2A2A2A] w-[375px] h-[246px]"
      headerStyle="bg-[#2A2A2A]"
    >
      <div className="flex items-center justify-center w-full fex flex-col px-4">
        <h3 className="text-white text-center text-xl font-bold leading-[normal] tracking-[0.4px] font-raleway">
          Ajouter catégorie conseil
        </h3>
        <form
          className="mt-9 flex flex-col gap-4 w-full"
          onSubmit={handleSubmitTipByCategory(addTipByCategoryHandler)}
        >
          <TextField
            inputStyle={{ background: '#1D1D1D' }}
            name="topic"
            register={registerTipByCategory('name')}
            textFieldType={TextfieldType.INPUT}
            placeholder="Nom de catégorie"
            helpText={(errorsTipByCategory?.name as FieldError)?.message}
            errorStyle="!text-red-500"
          />
          <Button
            type="submit"
            title={`Ajouter ${isAddingTipByCategory ? '...' : ''}`}
            className="w-full"
          />
        </form>
      </div>
    </Modal>
  );
};

export default AddNewTips;
